import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE, GET_PROFILE } from "./actionTypes"
import { fetchProfileSuccess, fetchProfileError, profileSuccess, profileError } from "./actions"

//Include Both Helper File with needed methods
import {
  postProfile,
  fetchProfile,
} from "../../../helpers/fakebackend_helper"

function* getProfile({ payload: username }) {
    try {
        console.log(username + " fetching profile");
        const users = yield call(fetchProfile, username);

        const user0 = Array.isArray(users) ? users[0] : null;

        if (!user0) {
            // This is the key: explicitly mark missing profile
            yield put(fetchProfileError({
                code: "PROFILE_MISSING",
                message: "Cognito login succeeded but SAGE profile does not exist yet.",
                username,
            }));
            return;
        }

        yield put(fetchProfileSuccess(user0));
    } catch (error) {
        yield put(fetchProfileError({
            code: "PROFILE_FETCH_FAILED",
            message: error?.message || "Unknown error fetching profile",
            raw: error,
            username,
        }));
    }
}


function* editProfile({ payload: profile  }) {
  try {
      const response = yield call(postProfile, profile)
      console.log(response)
      yield put(profileSuccess(profile))
  } catch (error) {
    yield put(profileError(error))
  }
}
export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(GET_PROFILE, getProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
